import { useEffect, useState } from "react";

import { Client } from "@/Common/Api/Client";
import { Locale } from "@/Common/Models/Localization/Locale";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ResourceProvider } from "@/Common/Resources/StaticResources";
import { LoginPage as MyleResoucesForLoginPage } from "@/Common/Resources/StaticResourcesFor";
import { Logo } from "@/DesignSystem/Atoms/Logo/Logo";
import { LoginLanguageHelper } from "./Login/Helpers/LoginLanguageHelper";
import { UrlService } from "./Services/UrlService";
import { NewExperienceLoginForm } from "./NewExperienceLoginForm";
import { VersionCheck } from "./VersionCheck";

import styles from "./NewExperienceLoginPage.module.scss";

export function NewExperienceLoginPage(): JSX.Element {
    const [stringProvider, setStringProvider] = useState<ResourceProvider>();
    const [language, setLanguage] = useState<Locale>();
    const [frontpageCampaignId, setFrontpageCampaignId] = useState<number>();

    useEffect(() => {
        const resources = new MyleResoucesForLoginPage();
        const currentLanguage = LoginLanguageHelper.getFirstLanguage(window["currentLang"]);

        setLanguage(currentLanguage);
        setStringProvider(new ResourceProvider(resources, currentLanguage));
    }, [language]);

    useEffect(() => {
        const getFrontPageCampaign = async (): Promise<void> => {
            const response = await Client.postAsync<{ FrontpageId: number }>(ServerOperations.Server.Myle_GetFrontpageCampaign, {});
            if (!response.errors?.length)
                setFrontpageCampaignId(response.data.FrontpageId);
        };

        getFrontPageCampaign();
    }, []);

    if (!stringProvider)
        return null;

    return (
        <div className={styles.mainContainer}>
            <VersionCheck />
            <div className={styles.loginContainer}>
                <div className={styles.logoContainer}>
                    <Logo language={language} />
                </div>
                <NewExperienceLoginForm
                    formTitle={stringProvider.GetString("LoginToYourAccountLabel")}
                    loginButtonTextKey="login"
                    language={language}
                    stringProvider={stringProvider}
                    loginOperation={LocalOperations.Login.OnLoginSubmit}
                />
                <div className={styles.copyrightContainer}>
                    &copy; {stringProvider.GetString("MedfarCopyRightLabel", { year: new Date().getFullYear() })}
                </div>
            </div>
            <div className={styles.notificationsContainer}>
                {frontpageCampaignId && language && (
                    <iframe
                        className={styles.campainFrame}
                        src={UrlService.getCampaignUrl(frontpageCampaignId, language)}
                        title="Medfar campains"
                    />
                )}
            </div>
        </div>
    );
}
